import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

import baraka from "../../../../images/client-logo/baraka.webp";
import green from "../../../../images/client-logo/green.webp";
import horizon from "../../../../images/client-logo/horizon.webp";
import ing from "../../../../images/client-logo/ing.jpg";
import lbp from "../../../../images/client-logo/lbp.webp";
import mg from "../../../../images/client-logo/mg.webp";


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const content = [
    {
        logo: baraka,
    },
    {
        logo: green,
    },
    {
        logo: horizon,
    },
    {
        logo: ing,
    },
    {
        logo: lbp,
    },
    {
        logo: mg,
    },
]


class ClientSlider1 extends Component {

    render() {

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        };

        const Border = this.props.hideBorder ? "" : "border"
        const padding = this.props.allowPadding ? "p-a25" : ""

        return (
            <>
                <Slider {...settings} className="client-logo-carousel btn-style-1 icon-2  home-slider2">
                    {content.map((item, id) => (
                        <div class="item">
                            <div class={`ow-client-logo ${padding}`}>
                                <div class={`client-logo ${Border}`}>
                                    <Link to="#"><img src={item.logo} alt="" /></Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>

            </>
        )
    }
}
export default ClientSlider1;